import DropdownSingleSelectQuestion from '../DropdownSingleSelectQuestion';
import GraphicSingleSelectQuestion from '../GraphicSingleSelectQuestion';
import PropTypes from 'prop-types';
import React from 'react';
import { ThumbnailType } from '../../../../bom/constants';
import { getUniqueOptions } from '../../../../bom/selectors';
import { useSelector } from 'react-redux';

const SingleSelectQuestion = ({ feedback, question, resetFeedback }) => {
  const { code, thumbnailType } = question;

  const options = useSelector((state) => getUniqueOptions(state, code));
  const hasNoColorReferences = options.every((option) => !option.colorReference);
  const dropdownMode =
    thumbnailType === ThumbnailType.LOCAL_IMAGE || thumbnailType === ThumbnailType.TEXT || hasNoColorReferences;

  return dropdownMode ? (
    <DropdownSingleSelectQuestion key={code} feedback={feedback} question={question} resetFeedback={resetFeedback} />
  ) : (
    <GraphicSingleSelectQuestion key={code} feedback={feedback} question={question} resetFeedback={resetFeedback} />
  );
};

SingleSelectQuestion.propTypes = {
  feedback: PropTypes.objectOf(PropTypes.string).isRequired,
  question: PropTypes.shape({
    code: PropTypes.string.isRequired,
    isRealParentChildQuestion: PropTypes.bool.isRequired,
    itemId: PropTypes.string.isRequired,
    mandatoryFlag: PropTypes.string.isRequired,
    needToReloadUniqueOptions: PropTypes.bool.isRequired,
    questionId: PropTypes.number.isRequired,
    questionLabel: PropTypes.string.isRequired,
    questionText: PropTypes.string.isRequired,
    questionType: PropTypes.oneOf([0, 1, 2, 3]).isRequired,
    representationType: PropTypes.oneOf([0, 1]).isRequired,
    sampleQuestionText: PropTypes.string,
    selectionType: PropTypes.oneOf([0, 1]).isRequired,
    sequence: PropTypes.number.isRequired,
    thumbnailType: PropTypes.oneOf([0, 1, 2, 3]).isRequired,
  }).isRequired,
  resetFeedback: PropTypes.func.isRequired,
};

export default SingleSelectQuestion;
